export default __webpack_public_path__ + "static/media/lcard_logo_for_free_trial.f21dbad2.png";